import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 500px;
  padding-top: 40px;
  align-items: center;
  justify-content: center;
`;